/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `name` - name * `email` - email * `gender` - gender * `role` - role * `groups` - groups * `user_permissions` - user_permissions * `is_active` - is_active * `therapist_profile` - therapist_profile * `appointment_resource` - appointment_resource * `patient_ops_profile` - patient_ops_profile * `photo` - photo * `signature` - signature
 */
export const EditableFieldsEnum = {
    Name: 'name',
    Email: 'email',
    Gender: 'gender',
    Role: 'role',
    Groups: 'groups',
    UserPermissions: 'user_permissions',
    IsActive: 'is_active',
    TherapistProfile: 'therapist_profile',
    AppointmentResource: 'appointment_resource',
    PatientOpsProfile: 'patient_ops_profile',
    Photo: 'photo',
    Signature: 'signature'
} as const;
export type EditableFieldsEnum = typeof EditableFieldsEnum[keyof typeof EditableFieldsEnum];

